var map = {
	"./0-dashboard.html": 206,
	"./1-left-right.html": 207,
	"./3-center.html": 208,
	"./4-middle.html": 209,
	"./5-inner.html": 210,
	"./6-holygrail.html": 211,
	"./8-img-board.html": 212,
	"./9-rounder.html": 213
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 205;


//////////////////
// WEBPACK FOOTER
// ./src/example nonrecursive ./node_modules/raw-loader ^[^_]+\.html$
// module id = 205
// module chunks = 1